export const CONSTANT_BUY = {
    shippingType: {
        0: "Envío acordado con el vendedor",
        1: "Guia prepagada de Sistema Apple",
        2: "Recoger en domicilio",
        3: "Costo de envío fijo",
        4: "Costo de envío acordado con el comprador"
    }
}

export const COMISSION = 30;

export const PRODUCT_CONSTANT = {
    TYPES: {
        PRODUCT: "product",
        SERVICE: "service"
    },
    STATE: {
        ON_HOLD: 0,
        ACTIVE: 1,
        CANCEL: 2,
        DELETE: 3,
        INACTIVE: 4
    }
}